import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'levelName'
})
export class LevelNamePipe implements PipeTransform {
    private translate = inject(TranslateService);

    transform(levelPosition: number): string {
        if (levelPosition === 0) {
            return this.translate.instant('RBR.LEVEL_NAME.GROUND_LEVEL');
        } else if (levelPosition > 0) {
            return `${this.translate.instant('RBR.LEVEL_NAME.UPPER_LEVEL')} ${levelPosition}`;
        } else {
            return `${this.translate.instant('RBR.LEVEL_NAME.UNDERGROUND_LEVEL')} ${levelPosition}`;
        }
    }
}
